var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page-ref-block"},_vm._l((_vm.model.teasers),function(teaser,i){return _c('PageTeaser',{key:i,attrs:{"model":teaser}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }